export const T = {
  en_GB: {
    rerunSearch: "Re-run Search",
    checkedNoMatches: "Checked - No PEP or Sanction matches found",
    checkedNoSanctionMatches: "Checked - No Sanction matches found",
    pepNotAssessed: "Not assessed",
    representativeResultHeading: "Per representative",
    subjectRepresentative: "representative",
    noRepresentativeHint:
      "PEP applies to a natural person, and no representative is registered for this client. Add one under Related parties, then re-run the screening.",
    pep: "PEP",
    sanctioned: "Sanctioned",
    yes: "Yes",
    no: "No",
    matchedIndividual: "Matched individual",
    matchedIndividuals: "Matched individuals",
    matchedEntity: "Matched entity",
    matchedEntities: "Matched entities",
    nameLabel: "Name:",
    birthLabel: "Birth:",
    countryLabel: "Country:",
    typeLabel: "Type:",
    orgLabel: "Org#:",
    pepSource: "PEP source",
    pepSources: "PEP sources",
    role: "Role",
    roles: "Roles",
    sanctionSource: "Sanction source",
    sanctionSources: "Sanction sources",
    search: "Search",
    test: "Test",
    reScreeningRequired: "Re-screening required",
    reScreeningExplanation:
      "This result was screened in test mode. Run the lookup again to screen against the production database before completing.",
  },
  nb_NO: {
    rerunSearch: "Kjør søk på nytt",
    checkedNoMatches: "Sjekket - Ingen PEP- eller sanksjonsforhold funnet",
    checkedNoSanctionMatches: "Sjekket - Ingen sanksjonsforhold funnet",
    pepNotAssessed: "Ikke vurdert",
    representativeResultHeading: "Per representant",
    subjectRepresentative: "representant",
    noRepresentativeHint:
      "PEP gjelder en fysisk person, og det er ikke registrert noen representant på denne kunden. Legg til en under Relaterte parter, og kjør sjekken på nytt.",
    pep: "PEP",
    sanctioned: "Sanksjonert",
    yes: "Ja",
    no: "Nei",
    matchedIndividual: "Treff på person",
    matchedIndividuals: "Treff på personer",
    matchedEntity: "Treff på virksomhet",
    matchedEntities: "Treff på virksomheter",
    nameLabel: "Navn:",
    birthLabel: "Fødsel:",
    countryLabel: "Land:",
    typeLabel: "Type:",
    orgLabel: "Org#:",
    pepSource: "PEP-kilde",
    pepSources: "PEP-kilder",
    role: "Rolle",
    roles: "Roller",
    sanctionSource: "Sanksjonskilde",
    sanctionSources: "Sanksjonskilder",
    search: "Søk",
    test: "Test",
    reScreeningRequired: "Ny screening kreves",
    reScreeningExplanation:
      "Dette resultatet ble screenet i testmodus. Kjør oppslaget på nytt for å screene mot produksjonsdatabasen før fullføring.",
  },
} as const;
